import api from '../token';

export const AddServico = async (dados) => {
  try {
    const response = await api.post('/addServico', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};









